export default {
  placeholder: 'Indtast restaurantens navn',
  labels: {
    cant_find_place: 'Kan du ikke finde stedet på listen?',
    reset_categories: 'Nulstil stedkategorier',
  },
};
